import React, { useEffect, useState } from "react";
import { adminApi } from "../api/adminApi";
import CreateUserModal from "../components/CreateUserModal";
import EditUserRolesModal from "../components/EditUserRolesModal";
import { adminTheme } from "styles/adminTheme.js"
import "../styles/admin-theme.css"

import RoleChip from "../components/RoleChip";
import StatusBadge from "../components/StatusBadge";
import AdminCard from "../components/AdminCard";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import BlockIcon from "@material-ui/icons/Block";          // Deaktivieren
import CheckCircleIcon from "@material-ui/icons/CheckCircle"; // Aktivieren



import {
    Card,
    CardHeader,
    CardContent,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    IconButton,
    Button,
    Chip,
    Typography,
    CircularProgress,
    Tooltip,
    makeStyles,
} from "@material-ui/core";
import { Add, Delete, Edit } from "@material-ui/icons";



const useStyles = makeStyles((theme) => ({
    card: {
        background: "#0f172a",
        color: "#e2e8f0",
    },
    headerRoot: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    actions: {
        display: "flex",
        gap: theme.spacing(1),
    },
    tableHead: {
        backgroundColor: "#020617",
    },
    tableHeadCell: {
        color: "#94a3b8",
        fontWeight: 600,
        fontSize: 12,
        textTransform: "uppercase",
    },
    roleChip: {
        marginRight: theme.spacing(0.5),
        marginBottom: theme.spacing(0.5),
    },
    statusChipActive: {
        backgroundColor: "#22c55e22",
        color: "#0891b2",
    },
    statusChipInactive: {
        backgroundColor: "#ef444422",
        color: "#0891b2",
    },
    emptyState: {
        padding: theme.spacing(3),
        textAlign: "center",
        color: "#94a3b8",
    },
    loadingWrapper: {
        padding: theme.spacing(3),
        display: "flex",
        justifyContent: "center",
    },
    buttonWarning: {
        background: "#f59e0b",
        color: "white",
        marginLeft: 8,
        padding: "6px 12px",
        border: "none",
        borderRadius: 6,
        cursor: "pointer"
    },

    buttonSuccess: {
        background: "#16a34a",
        color: "white",
        marginLeft: 8,
        padding: "6px 12px",
        border: "none",
        borderRadius: 6,
        cursor: "pointer"
    },

}));


export default function AdminUsersPage() {
    const classes = useStyles();
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [createOpen, setCreateOpen] = useState(false);
    const [editUser, setEditUser] = useState(null);

    const loadUsers = async () => {
        try {
            setLoading(true);
            setError(null);
            const data = await adminApi.getUsers();
            setUsers(data);
        } catch (err) {
            console.error(err);
            setError("Benutzer konnten nicht geladen werden.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadUsers();
    }, []);

    const handleDelete = async (id) => {
        if (!window.confirm("Benutzer wirklich löschen?")) return;
        try {
            await adminApi.deleteUser(id);
            await loadUsers();
        } catch (err) {
            console.error(err);
            alert("Fehler beim Löschen des Benutzers.");
        }
    };


    return (
        <>
            <Card className={classes.card}>
                <CardHeader
                    classes={{ root: classes.headerRoot }}
                    title={<Typography variant="h5" style={{ color: "#60a5fa" }}>Benutzerverwaltung</Typography>}
                    subheader={
                        <Typography variant="body2" style={{ color: "#94a3b8" }}>
                            Verwalte Benutzerkonten und Rollen der KIMAT-Plattform.
                        </Typography>
                    }
                    action={
                        <div className={classes.actions}>
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<Add />}
                                onClick={() => setCreateOpen(true)}
                            >
                                Neuer Benutzer
                            </Button>
                        </div>
                    }
                />
                <CardContent>
                    {loading ? (
                        <div className={classes.loadingWrapper}>
                            <CircularProgress />
                        </div>
                    ) : error ? (
                        <div className={classes.emptyState}>{error}</div>
                    ) : users.length === 0 ? (
                        <div className={classes.emptyState}>
                            Noch keine Benutzer vorhanden. Lege den ersten Benutzer an.
                        </div>
                    ) : (
                        <Table>
                            <TableHead className={classes.tableHead}>
                                <TableRow>
                                    <TableCell className={classes.tableHeadCell}>Benutzername</TableCell>
                                    <TableCell className={classes.tableHeadCell}>E-Mail</TableCell>
                                    <TableCell className={classes.tableHeadCell}>Status</TableCell>
                                    <TableCell className={classes.tableHeadCell}>Rollen</TableCell>
                                    <TableCell className={classes.tableHeadCell} align="right">
                                        Aktionen
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {users.map((u) => (
                                    <TableRow key={u.id} hover>
                                        <TableCell>{u.userName}</TableCell>
                                        <TableCell>{u.email}</TableCell>
                                        <TableCell>
                                            <td>
                                                <span
                                                    style={{
                                                        padding: "4px 10px",
                                                        borderRadius: 12,
                                                        fontSize: 12,
                                                        fontWeight: 600,
                                                        background: u.isActive ? "#16a34a" : "#991b1b",
                                                        color: "white"
                                                    }}
                                                        >
                                                    {u.isActive ? "Aktiv" : "Deaktiviert"}
                                                </span>
                                            </td>

    
                                        </TableCell>
                                        <TableCell>
                                            {u.roles && u.roles.length > 0 ? (
                                                u.roles.map(r => <RoleChip key={r} label={r} />)
                                            ) : (
                                                <Typography variant="caption" style={{ color: "#64748b" }}>
                                                    keine Rollen
                                                </Typography>
                                            )}
                                        </TableCell>
                                        <TableCell align="right">
                                            {/* 🔁 Aktivieren/Deaktivieren */}
                                            {u.isActive ? (
                                                <Tooltip title="Benutzer deaktivieren">
                                                <IconButton
                                                    size="small"
                                                    style={{ ...useStyles.iconButton, ...useStyles.iconWarn }}
                                                    onClick={async () => {
                                                        if (!window.confirm(`User "${u.userName}" deaktivieren?`)) return;
                                                        await adminApi.deactivateUser(u.id);
                                                        loadUsers();
                                                    }}
                                                >
                                                    <BlockIcon style={useStyles.icon} />
                                                    </IconButton>
                                                </Tooltip>
                                            ) : (
                                                    <Tooltip title="Benutzer aktivieren">
                                                        <IconButton
                                                        size="small"
                                                        style={{ ...useStyles.iconButton, ...useStyles.iconOk }}
                                                        onClick={async () => {
                                                            await adminApi.activateUser(u.id);
                                                            loadUsers();
                                                        }}
                                                        >
                                                        <CheckCircleIcon style={useStyles.icon} />
                                                        </IconButton>
                                                   </Tooltip>
                                            )}
                                            <Tooltip title="Rollen bearbeiten">
                                                <IconButton
                                                    size="small"
                                                    onClick={() => setEditUser(u)}
                                                >
                                                    <Edit style={{ fontSize: 18 }} />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Benutzer löschen">
                                                <IconButton
                                                    size="small"
                                                    onClick={() => handleDelete(u.id)}
                                                >
                                                    <Delete style={{ fontSize: 18 }} />
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    )}
                </CardContent>
            </Card>

            {createOpen && (
                <CreateUserModal
                    open={createOpen}
                    onClose={() => setCreateOpen(false)}
                    onSaved={loadUsers}
                />
            )}

            {editUser && (
                <EditUserRolesModal
                    open={!!editUser}
                    user={editUser}
                    onClose={() => setEditUser(null)}
                    onSaved={loadUsers}
                />
            )}
        </>
    );
}
